import { useState, useEffect, useRef } from "react";

function VideoPlayer({ src, resumeTime, onPause, onEnded }) {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const togglePlay = () => {
        const video = videoRef.current;
        if (!video) return;
        if (video.paused || video.ended) {
            video.play();
        } else {
            video.pause();
        }
    };

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <video
                ref={videoRef}
                className="scroll video-wrapper"
                style={{ border: 0, width: "100%" }}
                controls
                preload="auto"
                controlsList="nodownload"
                onLoadedMetadata={(e) => {
                    if (resumeTime > 0 && resumeTime < e.target.duration) {
                        e.target.currentTime = resumeTime;
                    }
                }}
                onPlay={handlePlay}
                onPause={(e) => {
                    handlePause();
                    onPause?.(e);
                }}
                onEnded={(e) => {
                    handlePause();
                    onEnded?.(e);
                }}
            >
                <source src={src} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {!isPlaying && (
                <div className="play-button-wrapper">
                    <div
                        title="Play video"
                        className="play-gif"
                        onClick={togglePlay}
                        style={{ cursor: "pointer" }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                            <path d="M40 0a40 40 0 1040 40A40 40 0 0040 0zM26 61.56V18.44L64 40z" />
                        </svg>
                    </div>
                </div>
            )}
        </div>
    );
}

export default VideoPlayer;
